import React from "react";
import generateXLSX from "../../utils/spreadsheets";
import { hasRoles } from "../../utils/roles";
import PropTypes from "prop-types";

ExportBenchmarkHeatMap.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  user: PropTypes.object,
};

export default function ExportBenchmarkHeatMap(props) {
  const { rows, columns, user } = props;

  if (hasRoles(user.roles, ["Client"])) {
    return null;
  }

  let headings = columns.map((p) => {
    return p.column_name;
  });

  let validData = [];

  rows.forEach((row) => {
    // Ensure the average is not a NaN so we know the row is valid
    if (isNaN(row.cells[2].field)) {
      return;
    }
    let cleanData = [];

    // Do not exceed the number of heading rows
    row.cells.forEach((c, i) => {
      if (i < headings.length) {
        cleanData.push(c.field);
      }
    });
    validData.push(cleanData);
  });

  validData.unshift(headings);

  return (
    <button
      className="estimate-export-button"
      onClick={() => {
        generateXLSX("Heatmap Export", validData);
      }}
    >
      <i className="fas fa-download"></i>
    </button>
  );
}
